import React, { useEffect } from "react";
import $ from "jquery";

function FAQPage () {

  let FAQList = [
    {
      id: "One",
      label: "Procore Integration",
      list: [
        {
          id: "00-00", question: "1. How do I set Procore Integration?",
          answer: <ul>
            <li>Choose a site from Dashboard to integrate with Procore.</li>
            <li>Navigate to 'Site Management' page.</li>
            <li>Navigate to ‘App Connectors’ tab.</li>
            <li>Click 'SIGNIN INTO YOUR PROCORE ACCOUNT TO CONNECT' button.</li>
            <li>Authenticate to Procore using your Procore credentials.</li>
            <li>Choose the Project related accounts from popup window.</li>
            <li>Procore integration success message will be displayed.</li>
            <li>As a final step, please check Daily logs and Settings box to complete the integration process.</li>
          </ul>
        },
        {
          id: "00-01", question: "2. How do I verify that my Procore account is setup to transfer daily logs and images?",
          answer: <p className="ml-4">After successful authentication with procore and choosing the project related info, Procore integration is done. <br />However, one should click 'Enable Procore Integration' checkbox and save 'Daily Log Submissions Settings' to transfer daily logs and images.</p>
        },
        {
          id: "00-02", question: "3. How do I know when to contact Support?",
          answer: <p className="ml-4">If you are having issues with seeing images in your Procore account even after checking ‘Daily Log Submission Settings’, please contact support. <br />Home &#10095; Support will have contact information to reach support team.</p>

        },
      ],
    },
    {
      id: "Two",
      label: "SiteSupt Settings",
      list: [
        {
          id: "01-00", question: "1. How do I set a default site so it navigates to it upon login?",
          answer: <p className="ml-4">Navigate to Settings page by selecting username drop down and choosing ‘Settings’. In the Settings page, under ‘Default View’ section, choose the desired site and save your selection.</p>
        },
        {
          id: "01-01", question: "2. How can I share Time-lapse video with other users?",
          answer: <ul>
            <li>While creating schedule, use the form input 'Share Video Link(s) with' to add comma separated email ids with whom you would like to share video.</li>
            <li>You can also share a Time-lapse video from Video History in View Time-lapse video tab. Select share button next to the video and provide desired email ids.</li>
          </ul>
        },
        {
          id: "01-02", question: "3. How can I update thresholds and get notifications?",
          answer: <ul>
            <li>Navigate to 'Site Management' in the application menu.</li>
            <li>For overall Site Settings, navigate to Site Settings tab, add desired thresholds, and set notifications.</li>
            <li>For zone specific settings, navigate to Zone Settings tab, add desired thresholds, and set notifications.</li>
          </ul>
        },
        {
          id: "01-03", question: "4. How do I contact support team if I have further questions?",
          answer: <p className="ml-4">Please navigate to our Support menu and reach us in any means provided. We will be happy to help!</p>
        },
      ],
    }
  ];

  useEffect(() => {
    // Add minus icon for collapse element which is open by default
    $(".collapse.show").each(function () {
      $().prev(".card-header").find(".fa").addClass("fa-angle-up").removeClass("fa-angle-down");
    });

    // Toggle plus minus icon on show hide of collapse element
    $(".collapse").on('show.bs.collapse', function () {
      $().prev(".card-header").find(".fa").removeClass("fa-angle-down").addClass("fa-angle-up");
    }).on('hide.bs.collapse', function () {
      $().prev(".card-header").find(".fa").removeClass("fa-angle-up").addClass("fa-angle-down");
    });
  },[]);

    return (
      <React.Fragment>
        <div className="page-container">
          <div className="row mb-4 px-0">
            <div id="accordion" style={{ width: '100%' }}>
              {FAQList.map((item, idx) => (
                <div key={idx} className="card">
                  <span className={item.id === "One" ? "card-header collapsed card-link" : "card-header card-link"}
                    data-toggle="collapse"
                    data-target={`#collapse${item.id}`}
                    aria-expanded={item.id === "One" ? "true" : "false"}
                    aria-controls={`collapse${item.id}`}
                    id={`heading${item.id}`}>
                    <b className="header-title float-left">
                      {item.label}</b>
                    <i className="fa fa-angle-down float-right "></i>
                  </span>
                  <div id={`collapse${item.id}`} className={item.id === "One" ? "collapse show" : "collapse"} aria-labelledby={`heading${item.id}`} data-parent="#accordion" >
                    <div className="card-body">
                      {item.list.map((q, i) => (
                        <div key={i} className="pb-2">
                          <div className="card-text hover-overlay mb-1 text-bold">{q.question}</div>
                          <div className="display-linebreak mb-1"> {q.answer} </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  
}

export default FAQPage;
